import RequiredAsterisk from '@/src/common/components/elements/Forms/RequiredAsterisk'
import {
    FieldWrapper,
    StyledLabel,
    TextInput,
} from '@/src/common/components/elements/Forms/StyledComponents'
import { styled } from '@/src/stitches.config'

const ContentWrapper = styled('div', {
    position: 'relative',
    variants: {
        showSymbol: {
            true: {
                '&::before': {
                    content: '$',
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '$darkest',
                },
            },
        },
    },
})

const StyledInput = styled(TextInput, {
    variants: {
        showSymbol: {
            true: {
                paddingLeft: 16,
            },
        },
    },
})

export const DenomInputWithLabel = (props: any) => {
    const {
        initialError,
        initialTouched,
        initialValue,
        touched,
        numFormat,
        value,
        label,
        placeholder,
        hasError,
        formErrors,
        isRequired,
        inputStyle,
        ...theRest
    } = props

    return (
        <FieldWrapper>
            <StyledLabel
                role="textbox"
                aria-label={`${label} input field`}
                htmlFor={props.name}
                css={{ marginRight: 15 }}
                hidden={!value && !placeholder}
            >
                {label}
                {props?.isRequired && <RequiredAsterisk />}
            </StyledLabel>
            <ContentWrapper showSymbol={!!value}>
                <StyledInput
                    value={value}
                    placeholder={placeholder ?? label}
                    className={hasError ? 'error' : null}
                    inputStyle={inputStyle}
                    showSymbol={!!value}
                    {...theRest}
                />
            </ContentWrapper>
        </FieldWrapper>
    )
}
